import { render, staticRenderFns } from "./IconHigh.vue?vue&type=template&id=6ec11d71&"
import script from "./IconHigh.vue?vue&type=script&lang=ts&"
export * from "./IconHigh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports